import { render } from "./detail-realisasi.vue?vue&type=template&id=0250a717"
import script from "./detail-realisasi.vue?vue&type=script&lang=js"
export * from "./detail-realisasi.vue?vue&type=script&lang=js"
script.render = render

export default script